import * as React from 'react';

import { AboutRealtorMobileContainer } from '../AboutRealtorContainer';
import { DescriptionMobileContainer } from '../DescriptionContainer/DescriptionMobileContainer';
import { RealtorInfoMobileWrapper } from './components/RealtorInfoMobileWrapper';
import { RealtorInfoMobileSection } from './components/RealtorInfoMobileSection';

export function RealtorInfoMobileContainer() {
  return (
    <RealtorInfoMobileWrapper>
      <RealtorInfoMobileSection>
        <AboutRealtorMobileContainer />
      </RealtorInfoMobileSection>
      <RealtorInfoMobileSection>
        <DescriptionMobileContainer />
      </RealtorInfoMobileSection>
    </RealtorInfoMobileWrapper>
  );
}
